//********************* GET ITEM TITLE ********************************//
// Display name for (app_id, item_id): "<app_name> #item_id".
// * appId (string|number) — GudHub app id
// * itemId (string|number) — GudHub item id
export async function getItemTitle(appId, itemId) {
    const app = await gudhub.getApp(appId);

    if (app?.field_id_for_item_name) {
        try {
            const interpreted = await gudhub.getInterpretationById(appId, itemId, app.field_id_for_item_name, 'value');
            if (interpreted) return interpreted;
        } catch(_) {}
    }

    return `${app?.app_name || 'Item'} #${itemId}`;
}

//********************* GET ITEM DEEP LINK ********************************//
// open_item route URL for (app_id, view_id, item_id).
// * appId (string|number) — GudHub app id
// * viewId (string|number|null) — GudHub view id
// * itemId (string|number) — GudHub item id
export function getItemDeepLink(appId, viewId, itemId) {
    return `/act/open_item/${appId}/${viewId || ''}/${itemId}`;
}

//********************* CHECK CURRENT USER APP ACCESS ********************************//
export async function checkCurrentUserAppAccess(appId) {
    const apps = await gudhub.getAppsList();
    return apps?.some(app => String(app.app_id) === String(appId)) ?? false;
}
